// src/components/congressional/MemberPhoto.jsx
// Congressional Trade Tracker — redesign (CONGRESSIONAL-PAGE-REDESIGN-DESIGN.md
// Sections 4.3/6). Renders an official member photo built entirely from
// BIOGUIDEID — zero backend change, zero new pipeline, zero new column.
// Source: unitedstates/images (GitHub, public domain — official congressional
// photos), path keyed by bioguide ID directly.
//
// Fail-safe, not fail-loud — same discipline TickerStatusBadge.jsx already
// applies to unknown status values: some historical or very-new members may
// not have an image in that repo at all. onError swaps to a neutral
// placeholder rather than a broken-image icon.

import { useState } from 'react';
import { User } from 'lucide-react';

// FIXED (real bug, confirmed via a HAR capture on the live deployed page —
// both photo requests returned 404): the original URL guessed
// raw.githubusercontent.com serving the 'main' branch, which is wrong on
// both counts. Confirmed against unitedstates/images' own README (and
// independently against its images/congress tree page and a fork's README,
// all three agreeing): photos are served via GitHub Pages from the
// 'gh-pages' branch, at unitedstates.github.io/images/congress/[size]/
// [bioguide].jpg — not raw.githubusercontent.com at all. Available sizes:
// original, 450x550, 225x275.
const PHOTO_BASE = 'https://unitedstates.github.io/images/congress/450x550/';

/**
 * @param {string} bioguideId
 * @param {number} size - square dimension in px (default 96)
 * @param {object} style - additional/override styles
 */
export default function MemberPhoto({ bioguideId, size = 96, style }) {
  const [failed, setFailed] = useState(false);

  if (!bioguideId || failed) {
    return (
      <div
        style={{
          width: size, height: size, borderRadius: '10px', flexShrink: 0,
          background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b',
          ...style,
        }}
      >
        <User size={Math.round(size * 0.45)} />
      </div>
    );
  }

  return (
    <img
      src={PHOTO_BASE + bioguideId + '.jpg'}
      alt=""
      onError={() => setFailed(true)}
      style={{
        width: size, height: size, borderRadius: '10px', objectFit: 'cover',
        flexShrink: 0, border: '1px solid rgba(255,255,255,0.1)', ...style,
      }}
    />
  );
}
